
<template>
<div class="relative">
    <router-link tag="div" to="/" style="float:left; margin-left: 5%;"> 
        <a><img src="/faviconMapgrafi.png" width="100px" alt="Logo"  class="img-fluid"></a>
    </router-link>
    <div class="vx-navbar-wrapper navbar-full p-0 search"  @click="showFullSearch= true" >
    <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses"  :color="navbarColor" style="background:none !important;"  >
            <p class="buscar" >Buscar...</p>
            <!-- SEARCHBAR -->
            <div class="search-full-container w-full h-full absolute left-0"  :class="{'flex': showFullSearch}" v-show="showFullSearch" >
                <vx-auto-suggest @click="showFullSearch = true"
                  class="w-full"
                  inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
                  :autoFocus="showFullSearch"
                  :data="navbarSearchAndPinList"
                  icon="SearchIcon"
                  placeholder="Search..."
                  ref="navbarSearch"
                  @closeSearchbar="showFullSearch = false"
                  @selected="selected"
                  background-overlay  />
                <div class="absolute right-0 h-full z-50"  >
                    <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon" ></feather-icon>
                </div>
            </div>
            <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search ml-4 icono_search"></feather-icon>

    </vs-navbar>
    </div>

    <div class="vx-row" style="float: right;">
        <div class="tipo_texto">
            <div class="mb-2 flex">
                <div class="mt-2">
                    <i class="material-icons">local_phone</i>
                </div>
                <div>
                    <span>¿Tiene alguna consulta?</span><br>
                        <b style="float:right!important;">
                        <a href="telf:+0442837629" target="_blank" style="color:rgb(13, 135, 59)">+593 4 283 7629</a>
                        </b>
                </div>
            </div>
        </div>

        <div class="tipo_texto">
            <div class="ml-2">
                <vs-button color="transparent" 
                    @click="documento()"
                    data-toggle="tooltip" data-placement="bottom" title="Facturación electrónica" data-original-title="Facturación electrónica" icon-pack="feather"  class="boton_tooltip">
                    <i class="material-icons" style="color:rgb(13, 135, 59)">description</i>
                </vs-button>
            </div>
        </div>

        <div v-if="user_state" class="" >
            <vs-button color="transparent" 
                @click="logout"
                data-toggle="tooltip" data-placement="bottom" title="Cerrar sesión" data-original-title="Cerrar sesión" icon-pack="feather"  class="boton_tooltip">
                <i class="material-icons" style="color:rgb(13, 135, 59)" title="Cerrar sesión">meeting_room</i> 
            </vs-button>
        </div>

        <div class="">
            <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <feather-icon icon="ShoppingCartIcon" class="cursor-pointer mr-6 mt-1" :badge="cartItems.length"></feather-icon>
                <vs-dropdown-menu class="cart-dropdown vx-navbar-dropdown" :class="{ 'dropdown-custom': cartItems.length }">

                    <template v-if="cartItems.length">
                        <div class="notification-header text-center p-5 bg-primary text-white">
                            <h3 class="text-white">{{ cartItems.length }} producto <span v-show="cartItems.length > 1"></span></h3>
                            <p class="opacity-75">En el carrito</p>  
                                <a> 
                                    <i data-toggle="tooltip" data-placement="bottom" title="Vaciar el carrito" data-original-title="Vaciar el carrito"  class="material-icons" @click="popupDeleteCart = !popupDeleteCart">remove_shopping_cart</i>
                                </a>
                        </div>

                        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10" :settings="settings">
                        <ul class="bordered-items">
                            <li v-bind:key="index" v-for="(item, index) in cartItems" class="vx-row no-gutter cart-item">

                                <template v-if="item.imageUrl == ''" >
                                <div class="vx-col w-1/5 item-img-container bg-white flex items-center justify-center">
                                    <img  v-bind:src="require('@/assets/images/no-imagen.jpg')" alt="item" class="cart-dropdown-item-img p-4">
                                </div>
                                </template>
                                <template v-else>
                                    <div class="vx-col w-1/5 item-img-container bg-white flex items-center justify-center">
                                        <img  v-bind:src="$store.state.api + 'mapgrafi/ecommerce/searchFile/' + item.imageUrl" alt="item" class="cart-dropdown-item-img p-4">
                                    </div>
                                </template>
                                <div class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center">
                                    <span class="font-medium block cart-item-title truncate">{{ item.name }}</span>
                                    <small class="truncate mb-2">{{ item.description }}</small>
                                    <div data-toggle="tooltip" data-placement="bottom" title="Eliminar producto" data-original-title="Eliminar producto" class="flex items-center justify-between">
                                        <span class="text-sm font-medium">{{ parseInt(item.quantity) }} <small>x</small> ${{ parseFloat(item.price).toFixed(2) }}</span>
                                            <feather-icon icon="XIcon" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger" @click.stop="(statusPreventa == true ? null : removeItemFromCart(item))" />
                                    </div>
                                    <small class="font-medium block cart-item-title truncate" style="font-weight: bold !important;">  
                                        {{ item.student.nombre_completos }}
                                        </small>
                                </div>
                            </li>
                        </ul>
                        </VuePerfectScrollbar>
                        <div
                            class=" checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                            @click="$router.push('/list/checkout-products').catch(() => { })">

                            <span class="flex items-center justify-center" style="color:#000;">
                                <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4"></feather-icon>
                                <span class="ml-2">Mirar tus productos</span>
                            </span>

                        </div>
                    </template>

                    <template v-else>
                        <p class="p-4">Tu carrito está vacio.
                        </p>
                    </template>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        
    </div>



    

    

    

    <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupDeleteCart">
            <p>¿Desea vaciar el carrito?, Tiene <b>{{ cartItems.length  }}</b>  productos.
                <br>
            </p>
            <div class="flex flex-wrap justify-between mb-3">
                <vs-button  color="primary"  @click="(deleteAllCart()),(popupDeleteCart = !popupDeleteCart)">Aceptar</vs-button>
                <vs-button  color="danger"  @click="popupDeleteCart = !popupDeleteCart">Cancelar</vs-button>
            </div>
    </vs-popup>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import draggable from 'vuedraggable'

export default {
    name: "the-navbar",
    props: {
      logo: { type: String },
      navbarType: {
        type: String,
        required: true
      }
    },
    data() {
        return {
            popupDeleteCart:false,
            navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
            searchQuery: '',
            showFullSearch: false,
            unreadNotifications: [
                { index: 0, title: 'New Message', msg: 'Are your going to meet me tonight?', icon: 'MessageSquareIcon', time: this.randomDate({sec: 10}), category: 'primary' },
                { index: 1, title: 'New Order Recieved', msg: 'You got new order of goods.', icon: 'PackageIcon', time: this.randomDate({sec: 40}), category: 'success' },
                { index: 2, title: 'Server Limit Reached!', msg: 'Server have 99% CPU usage.', icon: 'AlertOctagonIcon', time: this.randomDate({min: 1}), category: 'danger' },
                { index: 3, title: 'New Mail From Peter', msg: 'Cake sesame snaps cupcake', icon: 'MailIcon', time: this.randomDate({min: 6}), category: 'primary' },
                { index: 4, title: 'Bruce\'s Party', msg: 'Chocolate cake oat cake tiramisu', icon: 'CalendarIcon', time: this.randomDate({hr: 2}), category: 'warning' },
            ],
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            autoFocusSearch: false,
            showBookmarkPagesDropdown: false,
        }
    },
    watch: {
        '$route'() {
            if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
        }
    },
    computed: {
        statusPreventa(){
            var statusPreventa    =   JSON.parse(localStorage.getItem('statusPreventa'));
            return statusPreventa;
        },
        navbarColor() {
            let color = "#fff"
            if(this.navbarType === "sticky") color = "#f7f7f7"
            else if(this.navbarType === 'static') {
            if(this.scrollY < 50) {
                color = "#f7f7f7"
            }
            }

            this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

            return color
        },
        isThemedark() {
            return this.$store.state.theme;
        },
        navbarStyle() {
          let style = {}

          if(this.navbarType === "static") {
            style.transition = "all .25s ease-in-out"

            // if(this.scrollY < 50) {
            //   style.background = "#262c49"
            // }
          }
          return style
        },
        navbarClasses() {
          return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none"
        },
        scrollY() {
          return this.$store.state.scrollY
        },

        // HELPER
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },

        // I18N
        getCurrentLocaleData() {
            const locale = this.$i18n.locale;
            if (locale == "es") return { flag: "us", lang: 'Spanish' }
        },

        // BOOKMARK & SEARCH
        data() {
            return this.$store.state.navbarSearchAndPinList;
        },
        starredPages() {
            return this.$store.state.starredPages;
        },
        starredPagesLimited: {
            get() {
                return this.starredPages.slice(0, 10);
            },
            set(list) {
                this.$store.dispatch('arrangeStarredPagesLimited', list);
            }
        },
        starredPagesMore: {
            get() {
                return this.starredPages.slice(10);
            },
            set(list) {
                this.$store.dispatch('arrangeStarredPagesMore', list);
            }
        },

        // CART DROPDOWN
        cartItems() {
            return this.$store.state.eCommerce.cartItems.slice().reverse();
        },

        // PROFILE
        activeUserInfo() {
          return this.$store.state.AppActiveUser
        },
        user_displayName() {
            return this.activeUserInfo.displayName
        },
        user_stateValue() {
            return this.activeUserInfo.statusValue
        },
        user_state() {
            return this.activeUserInfo.status
        },
        activeUserImg() {
            return this.$store.state.AppActiveUser.photoURL;
        }
    },
    methods: {
        documento(){
          window.open('http://facturacion.viadoc.com.ec/index_mapgrafi.php');
        },
        deleteAllCart(){
            this.$vs.loading(); 
            this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                evento    : "DELETE",
                id_usuario: this.activeUserInfo.id_usuario,
                carrito   : null,
                cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,

            })
            .then((response) => {
                if(response.data.existeError) throw response.data.mensaje;
                if (response.data.data[0].id_insertado == '1') {
                    this.$store.dispatch('eCommerce/deleteItems')
                    .then(respuesta=>{
                        this.$vs.loading.close(); 
                    })
                    .catch(() => {
                        this.$vs.loading.close(); 
                    });
                }
            })
            .catch(() => {
                this.$vs.loading.close(); 
            })
        }, 
        updateLocale(locale) {
            this.$i18n.locale = locale;
        },
        selected(item) {
            this.$router.push(item.url).catch(() => {})
            this.showFullSearch = false;
        },
        actionClicked(item) {
            // e.stopPropogation();
            this.$store.dispatch('updateStarredPage', { index: item.index, val: !item.highlightAction });
        },
        showNavbarSearch() {
            this.showFullSearch = true;
        },
        showSearchbar() {
            this.showFullSearch = true;
        },
        elapsedTime(startTime) {
            let x = new Date(startTime);
            let now = new Date();
            var timeDiff = now - x;
            timeDiff /= 1000;

            var seconds = Math.round(timeDiff);
            timeDiff = Math.floor(timeDiff / 60);

            var minutes = Math.round(timeDiff % 60);
            timeDiff = Math.floor(timeDiff / 60);

            var hours = Math.round(timeDiff % 24);
            timeDiff = Math.floor(timeDiff / 24);

            var days = Math.round(timeDiff % 365);
            timeDiff = Math.floor(timeDiff / 365);

            var years = timeDiff;

            if (years > 0) {
                return years + (years > 1 ? ' Years ' : ' Year ') + 'ago';
            } else if (days > 0) {
                return days + (days > 1 ? ' Days ' : ' Day ') + 'ago';
            } else if (hours > 0) {
                return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago';
            } else if (minutes > 0) {
                return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago';
            } else if (seconds > 0) {
                return seconds + (seconds > 1 ? ' sec ago' : 'just now');
            }

            return 'Just Now'
        },
        logout() {
            this.$store.dispatch('eCommerce/deleteItems')
            // if user is logged in via auth0
            if (this.$auth.profile) this.$auth.logOut()

            // if user is logged in via firebase
            const firebaseCurrentUser = firebase.auth().currentUser

            if (firebaseCurrentUser) {
                firebase.auth().signOut().then(() => {
                    this.$router.push('/').catch(() => {})
                })
            }
            // If JWT login
            if(localStorage.getItem("accessToken")) {
              localStorage.removeItem("accessToken")
              this.$router.push('/').catch(() => {})
            }

            // Change role on logout. Same value as initialRole of acj.js
            this.$acl.change('')
            localStorage.removeItem('userInfo')
            localStorage.removeItem('student')
            localStorage.removeItem('list_direcciones')

            // This is just for demo Purpose. If user clicks on logout -> redirect
            this.$router.push('/').catch(() => {})
            location.reload();
        },
        outside: function() {
            this.showBookmarkPagesDropdown = false
        },

        // CART DROPDOWN
        removeItemFromCart(item) {
            this.$store.dispatch('eCommerce/toggleItemInCart', item)
                this.$http.post(this.$store.state.domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`,{
                evento    : "GUARDAR",
                id_usuario: this.activeUserInfo.id_usuario,
                carrito   : (localStorage.getItem('carItems')),
                cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,

            })
            .then((response) => {
                this.$vs.loading.close(); 
            })
            .catch(() => {
                this.$vs.loading.close(); 
            });
        },

        // Method for creating dummy notification time
        randomDate({hr, min, sec}) {
          let date = new Date()

          if(hr) date.setHours(date.getHours() - hr)
          if(min) date.setMinutes(date.getMinutes() - min)
          if(sec) date.setSeconds(date.getSeconds() - sec)

          return date
        }
    },
    directives: {
        'click-outside': {
            bind: function(el, binding) {
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler
                document.addEventListener('click', handler)
            },

            unbind: function(el) {
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    },
    components: {
        VxAutoSuggest,
        VuePerfectScrollbar,
        draggable
    },
}
</script>

<style>


.boton_tooltip{
    margin: 0px !important;
    padding: 5px !important;
}

@media screen and (max-width: 600px) {
    .img-fluid {
      display:none;
    }
    .search{
      margin-left: 7% !important;
    }
    .buscar{
        left: 10% !important;
    }
    .icono_search{
        left: 45% !important;
    }
    .item_productos{
        margin-right: 20px !important;
    }
    .item_exit{
         padding-left:2px!important; padding-right:0px!important;
    }
    .tipo_texto{
        display: none;
    }

}
@media screen and (min-width: 601px) and (max-width: 1000px) {
    .tipo_texto{
        display: none;
    }
    .icono_search{
        left: 40% !important;
    }
}
    .search{
        margin-left: 23%; 
        cursor:pointer!important;
        top: 10%; 
        position: absolute!important;
        width: 43%!important;  
        background: white!important;
        height: auto!important;
        border-radius: 10px!important;
    }
    .buscar{
        position: fixed; left: 25%;
    }
    .item_productos{
        float:right;
    }
    .item_exit{
        float:right; padding-left:0px; padding-right:0px;
    }
    .tipo_texto{
        float:right;
    }
</style>